module.exports = __webpack_public_path__ + "img/right-from-line.3ef0d80b.svg";